import { render, staticRenderFns } from "./AmenityItem.vue?vue&type=template&id=71d22136&"
import script from "./AmenityItem.vue?vue&type=script&lang=js&"
export * from "./AmenityItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports